import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
    return (
        <div className="disappear card mx-auto d-flex flex-column justify-content-between">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => onSuggestionSelect(suggestion)}
                >
                    {suggestion.Manufacturer} {suggestion.ModelName}
                </div>
            ))}
        </div>
    );
}

export default function Trains() {
    const [trains, setTrains] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedTrain, setSelectedTrain] = useState(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    useEffect(() => {
        const searchInput = document.querySelector(".search-input");
        const suggestionsList = document.querySelector(".disappear");

        function handleClickOutside(event) {
            if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
                setFilteredSuggestions([]);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchTrains();
    }, []);

    async function fetchTrains() {
        try {
            const fetchedTrains = await DataStore.query(VehicleModelGeneralInfo);
            setTrains(fetchedTrains);
        } catch (error) {
            console.error("Error fetching trains:", error);
        }
    }

    function filterTrains(train, searchQuery) {
        const words = searchQuery.toLowerCase().split(" ");
        return (
            train.VehicleType === "TRAIN" &&
            train.Manufacturer &&
            train.ModelName &&
            words.every(
                (word) =>
                    train.Manufacturer.toLowerCase().includes(word) ||
                    train.ModelName.toLowerCase().includes(word)
            )
        );
    }

    function handleInputChange(event) {
        const query = event.target.value;
        setSearchQuery(query);
        const suggestions = trains.filter((train) => filterTrains(train, query));
        setFilteredSuggestions(suggestions);
    }

    function handleSuggestionSelect(suggestion) {
        setSelectedTrain(suggestion);
        setFilteredSuggestions([]); // Clear suggestions
    }

    function toggleSuggestions() {
        if (filteredSuggestions.length > 0) {
            setFilteredSuggestions([]);
        } else {
            const trainsOnly = trains.filter(train => train.VehicleType === "TRAIN");
            setFilteredSuggestions(trainsOnly);
        }
    }

    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <input
                    className="search-input card mx-auto d-flex flex-column justify-content-between"
                    type="text"
                    placeholder="Click here to see trains or search train models..."
                    value={searchQuery}
                    onChange={handleInputChange}
                    onClick={toggleSuggestions}
                    style={{ padding: "10px", marginBottom: "5px" }}
                />

                {filteredSuggestions.length > 0 && (
                    <Suggestions
                        suggestions={filteredSuggestions}
                        onSuggestionSelect={handleSuggestionSelect}
                    />
                )}
            </div>

            {selectedTrain && (
                <div className="homepageCarousel">
                    <Card className="card mx-auto d-flex flex-column justify-content-between">
                        <div>
                            <Card.Img
                                variant="top"
                                src={selectedTrain.Picture}
                                alt={`Slide Train`}
                            />
                            <Card.Body className="card-body"
                                style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <Card.Text>Manufacturer: {selectedTrain.Manufacturer}</Card.Text>
                                <Card.Text>Model Name: {selectedTrain.ModelName}</Card.Text>
                                <Card.Text>Model Year: {selectedTrain.ModelYear}</Card.Text>
                                <Card.Text>Body Style: {selectedTrain.BodyStyle}</Card.Text>
                                <Card.Text>Engine Type: {selectedTrain.EngineType}</Card.Text>
                                <Card.Text>Fuel Type: {selectedTrain.FuelType}</Card.Text>
                                <Card.Text>Transmission: {selectedTrain.Transmission}</Card.Text>
                                <Card.Text>Top Speed: {selectedTrain.TopSpeed}</Card.Text>
                                <Card.Text>Dimensions: {selectedTrain.Dimensions}</Card.Text>
                                <Card.Text>Weight: {selectedTrain.Weight}</Card.Text>
                                <Card.Text>Seating Capacity: {selectedTrain.SeatingCapacity}</Card.Text>
                                <Card.Text>Country Of Origin: {selectedTrain.CountryOfOrigin}</Card.Text>
                                <Card.Text>Price: {selectedTrain.Price}</Card.Text>
                                <Card.Text>Information: {selectedTrain.Information}</Card.Text>
                            </Card.Body>



                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
}

